module.exports = __webpack_public_path__ + "img/speech-recognition.4ef5dd7b.png";